import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EventType } from './calendar.types';

import styles from './EventTypeSelection.module.scss';

export const eventTypeTranslationKeys: {
  [type in EventType]: 'event.visit.type' | 'event.meeting.type';
} = {
  Visit: 'event.visit.type',
  Meeting: 'event.meeting.type',
};

export const EventTypeSelection: FC<{
  eventType: EventType;
  onEventTypeChanged: (newEventType: EventType) => void;
}> = (props) => {
  const i18n = useTranslation();

  return (
    <div className={styles.eventTypeSelection}>
      <ToggleButtonGroup
        value={props.eventType}
        exclusive
        onChange={(_e, value) => props.onEventTypeChanged(value)}
      >
        <ToggleButton value={'Visit'} className={styles.eventTypeButton}>
          {i18n.t(eventTypeTranslationKeys['Visit'])}
        </ToggleButton>
        <ToggleButton value={'Meeting'} className={styles.eventTypeButton}>
          {i18n.t(eventTypeTranslationKeys['Meeting'])}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
